import styled from "styled-components"

const SearchButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const NotificationButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { SearchButton, NotificationButton }
